import { Language, Mandant, UserRole, WorkFormPage } from '../util/types';
import { SearchRequestSort } from '../api/core';
import { organisationsSortOptions, personsSortOptions, projectsSortOptions, worksSortOptions } from './data';

export const pwPlaceholder: string = '********';
export const searchTimerTimeout: number = 800;
export const momentDateFormat: string = 'DD.MM.YYYY';

// PAGINATION SETTINGS
export const pageSizeOptions: number[] = [10, 20, 50, 100];
export const defaultRowsPerPage: number = pageSizeOptions[0];
export const defaultFacetsPerPage: number = pageSizeOptions[0];
export const defaultPageSize: number = defaultRowsPerPage;

// SIDEBAR
export const sidebarBreakPoint: number = 992;

// AVAILABLE VALUES

// DEFAULT VALUES
export const defaultUserRole: UserRole = 'ROLE_USER';
export const defaultTheme: Mandant = 'rub';
export const defaultOrigin: Mandant = 'tudo';
export const defaultLanguage: Language = 'de';
export const initialCslLocale = 'de-DE';
export const searchDelayDefault: number = 400;

// WORK SEARCH RESULT SETTINGS
export const authorsPreviewWorkResult: number = 3;
export const authorsSeparator: string = '; ';
export const worksDefaultSort: SearchRequestSort = worksSortOptions[3].value;
export const projectsDefaultSort: SearchRequestSort = projectsSortOptions[1].value;
export const organisationsDefaultSort: SearchRequestSort = organisationsSortOptions[1].value;
export const personsDefaultSort: SearchRequestSort = personsSortOptions[1].value;

export const workFormDefaultPage: WorkFormPage = 'basic';

export const maxImageSizeMb: number = 1;
export const maxFileSize: number = 16777216; // 16 MB

export const dateConfig: Intl.DateTimeFormatOptions = {day: '2-digit', month: '2-digit', year: 'numeric'};
export const dateTimeConfig: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
};

export const headerExcludedRoles: string[] = ['dgs', 'ths', 'mms_th2', 'his', 'hnr', 'dgg', 'mms_rea'];

export const validSearchFieldNames: string[] = ['id', 'isbn'];